var productCardMarkup = 
    `<div class="swym-wishlist-grid">
{{#products}} 
<a aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
<div class="select-product">
<div class="select-product-inner">
<input type="checkbox" name="wislistproduct" class="select-product-checkbox" id="select-product">
<span class="checkmark"></span>
</div>
</div>
<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
<div class="swym-title swym-title-1">
{{dt}}
</div></button>
<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
{{variantinfo}}
</div>
<div class="price-btn-container">
<div class="swym-product-price swym-text swym-text-1">
<div class="swym-product-final-price swym-value">
{{cu}}{{pr}}&nbsp;({{cu}}{{pr}} inc.VAT)
</div>
</div>

<div class="qty-btn-container">
<div class="qtybox">
<span class="wishlist-qty-minus" data-field="quantity">-</span>
<input
type="text"
id="quantity"
name="quantity"
value="1"
min="1"
class="quantity-selector quantity-input"
readonly
/>
<span class="wishlist-qty-plus" data-field="quantity">+</span>
</div>
<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
{{#isInCart}}Add{{/isInCart}}{{^isInCart}}Add{{/isInCart}}<span id="custom-add-loader" class="atc-button--icon">
<svg class="icon-spinner " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">          <title>Spinner icon</title><circle opacity="0.29" cx="13" cy="13" r="11" stroke="currentColor" stroke-width="2"></circle>
<path d="M24 13C24 19.0751 19.0751 24 13 24" stroke="currentColor" stroke-width="2"></path> 
</svg></span>
</button>

</div>
<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">Remove From Favourites</span></button>
</div>
</a> 
{{/products}}
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
        variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    console.log(products)
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    var formattedWishlistedProducts = products.reverse().map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts
    });
    if(wishlistContentsContainer){
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else{
      console.log("Container not found, Wishlist Page element not found");
    }
    if (products.length == 0){
      $('#wishlist-items-container .swym-wishlist-grid').append('<h5 class="empty-favorites">Favourites is Empty</h5>');
      $('.all-product').hide();
    }
    else{
      $('.all-product').show();
    }
  });

}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  var parent = $(e.target).closest('div');
  var qty = parent.find('input[name=quantity]').val();

 e.target.querySelector('#custom-add-loader').style.display = "block";   
  
//   var divLoader = document.getElementById("custom-add-loader");  
//   divLoader.style.display = "block";  
  window._swat.replayAddToCart({
    empi: productId,
    du: du,
    qty: qty
  }, variantId, function(c) {
   e.target.querySelector('#custom-add-loader').style.display = "none";   
  
    e.target.setAttribute("data-state-cart", "swym-added");
    // console.log("Successfully added product to cart.", c);
    addedCart();

  }, function(e) {
    console.log(e);
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  var qtyMinus = document.querySelectorAll(".wishlist-qty-minus");
  var qtyPlus = document.querySelectorAll(".wishlist-qty-plus");
  var selectAll = document.querySelectorAll("#add-all-products");
  var count = 0;

  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }

  for (var i = 0; i < qtyMinus.length; i++) {
    qtyMinus[i].addEventListener('click', onMinusClick, false);
  }

  for (var i = 0; i < qtyPlus.length; i++) {
    qtyPlus[i].addEventListener('click', onPlusClick, false);
  }

  for (var i = 0; i < selectAll.length; i++) {
    selectAll[i].addEventListener('click', function(){ addAllClick(count) }, false);
  }

  console.log("Events attached!");
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
} 

function onMinusClick(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(1);
  }
}
function onPlusClick(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(1);
  }
}

function addedCart(e){
  
  if($('body').hasClass('temp-swym')){
    $.get( "/cart?view=fetch", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
    });
    
    jQuery.get( "/cart.json", function(item) {
      var totalQty = item['item_count'];
      jQuery('.site-header-cart--count').attr('data-header-cart-count',totalQty);
    });

  }
}

function ajax(item,count) {
  if($(item).is(":checked")){

    var parent = $(item).closest('.swym-wishlist-item');
    var addBtn = $(parent).find('#swym-custom-add-toCartBtn');
    var productId = $(addBtn).attr("data-product-id");
    var variantId = $(addBtn).attr("data-variant-id");
    var du = $(addBtn).attr("data-product-url");
    var qty = $(parent).find('input[name=quantity]').val();

    $(addBtn).text('Adding..');
    window._swat.replayAddToCart({
      empi: productId,
      du: du,
      qty: qty
    }, variantId, function(c) {
      $(addBtn).text("Added");
      $(addBtn).attr("data-state-cart", "swym-added");
      console.log("Successfully added product to cart.");
      addedCart();
      let cnt = count+1;
      addAllClick(cnt);

    }, function(e) {
      console.log(e);
    });
  } 	 
}

function addAllClick(count){
  if($("#wishlist-items-container #select-product").length != count  )
  {
    ajax($("#wishlist-items-container #select-product")[count],count)
  }
}

$(document).ready(function() {
  $('#all-product').on('click',function(){
    if(this.checked){
      $('#wishlist-items-container #select-product').each(function(){
        this.checked = true;
      });
    }else{
      $('#wishlist-items-container #select-product').each(function(){
        this.checked = false;
      });
    }
  });
});